import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode, NodeField, NodeTextarea } from './baseNode';

export const ConditionNode = ({ id, data }) => {
  const [condition, setCondition] = useState(data?.condition || 'input !== ""');

  const handles = [
    { type: 'target', position: Position.Left,  id: `${id}-input`,  style: { top: '50%' } },
    { type: 'source', position: Position.Right, id: `${id}-true`,   style: { top: '74%' } },
    { type: 'source', position: Position.Right, id: `${id}-false`,  style: { top: '88%' } },
  ];

  return (
    <BaseNode label="Condition" color="#f97316" handles={handles}>
      <NodeField label="If condition (JS)">
        <NodeTextarea
          rows={2}
          value={condition}
          onChange={e => setCondition(e.target.value)}
          placeholder="input !== ''"
        />
      </NodeField>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, fontSize: 10 }}>
        <span style={{ color: '#16a34a', fontWeight: 600 }}>true →</span>
        <span style={{ color: '#dc2626', fontWeight: 600 }}>false →</span>
      </div>
    </BaseNode>
  );
};